import { v4 as uuidv4 } from 'uuid';
import { normalizeHexColor } from './richText.js';
import { normalizeStoredImageItem, revokeLocalImageUrl } from './localImage.js';
import { LOCAL_ASSET } from './localAssets.js';
import { getMediaItemUrl } from './qiniuMedia.js';

export const IMAGE_COLLAGE_TYPE = 'image-collage';
export const IMAGE_COLLAGE_ITEM_COUNT = 4;
export const IMAGE_COLLAGE_DEFAULT_RADIUS = 8;
export const IMAGE_COLLAGE_GAP = 8;
export const IMAGE_COLLAGE_DEFAULT_TITLE_COLOR = '#ffffff';

const ITEM_PRESETS = [
	{ title: '轻盈护手霜' },
	{ title: '绵润易吸收' },
	{ title: '植萃保湿' },
	{ title: '随身好带' },
];

function createDefaultImage(index = 0) {
	const sources = LOCAL_ASSET.imgCollage || [];
	return {
		id: `image-collage-img-${uuidv4()}`,
		filename: `img-collage-${(index % sources.length) + 1}.png`,
		previewUrl: sources[index % sources.length] || '',
		url: '',
		local: false,
	};
}

export function createDefaultImageCollageItem(preset = {}, index = 0) {
	const fallback = ITEM_PRESETS[index] || {};
	return {
		id: uuidv4(),
		title: preset.title ?? fallback.title ?? '',
		titleColor: IMAGE_COLLAGE_DEFAULT_TITLE_COLOR,
		image: createDefaultImage(index),
		jumpLink: null,
	};
}

export function createDefaultImageCollageItems() {
	return ITEM_PRESETS.map((preset, index) => createDefaultImageCollageItem(preset, index));
}

export function getImageCollageDefaults() {
	return normalizeImageCollageData({
		items: createDefaultImageCollageItems(),
	});
}

export function isImageCollageBlock(blockType) {
	return blockType === IMAGE_COLLAGE_TYPE;
}

export function getImageCollageImageUrl(image) {
	if (!image) return '';
	return getMediaItemUrl(image);
}

function normalizeCardImage(image, fallback) {
	if (!image?.previewUrl && !image?.url) {
		return fallback ? { ...fallback } : null;
	}
	return normalizeStoredImageItem(image, fallback);
}

export function normalizeImageCollageItem(item = {}, index = 0) {
	const fallback = createDefaultImageCollageItem({}, index);
	return {
		id: item.id || uuidv4(),
		title: item.title ?? fallback.title,
		titleColor: normalizeHexColor(item.titleColor || fallback.titleColor || IMAGE_COLLAGE_DEFAULT_TITLE_COLOR),
		image: normalizeCardImage(item.image, fallback.image),
		jumpLink: item.jumpLink?.type ? { ...item.jumpLink } : null,
	};
}

export function normalizeImageCollageItems(items = []) {
	if (!Array.isArray(items) || !items.length) {
		return createDefaultImageCollageItems();
	}
	const next = items.slice(0, IMAGE_COLLAGE_ITEM_COUNT).map((item, index) => (
		normalizeImageCollageItem(item, index)
	));
	while (next.length < IMAGE_COLLAGE_ITEM_COUNT) {
		next.push(createDefaultImageCollageItem({}, next.length));
	}
	return next;
}

export function normalizeImageCollageData(data = {}) {
	const radius = Number(data.borderRadius);

	return {
		items: normalizeImageCollageItems(data.items),
		borderRadius: Number.isFinite(radius)
			? Math.max(0, radius)
			: IMAGE_COLLAGE_DEFAULT_RADIUS,
		gap: Number.isFinite(Number(data.gap)) ? Math.max(0, Number(data.gap)) : IMAGE_COLLAGE_GAP,
	};
}

export function getImageCollageBlockStyle(data = {}, { h5 = false } = {}) {
	const normalized = normalizeImageCollageData(data);
	const pxRatio = h5 ? 50 : 1;
	const radius = normalized.borderRadius;
	const gap = normalized.gap;

	return {
		borderRadius: h5 ? `${radius / pxRatio}rem` : `${radius}px`,
		gap: h5 ? `${gap / pxRatio}rem` : `${gap}px`,
	};
}

export function replaceImageCollageImage(currentImage, file, createLocalImageItem) {
	if (currentImage?.local) {
		revokeLocalImageUrl(currentImage.previewUrl);
	}
	return createLocalImageItem(file);
}
